var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { width: _vm.dialogWidth },
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          $event.preventDefault()
          return _vm.onenter.apply(null, arguments)
        },
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        {
          staticClass: "resizable-card",
          class: { "no-select": _vm.resizing },
          style: { height: _vm.dialogHeight + "px" },
        },
        [
          _c(
            "v-card-title",
            [
              _c("span", { staticClass: "headline" }, [
                _vm._v("Item Kind (" + _vm._s(_vm.rules.name) + ")"),
              ]),
              _c("v-spacer"),
              _c("r-authorize", {
                attrs: {
                  master: _vm.masterAccess,
                  locked: _vm.model.locked,
                  enabled: _vm.model.enabled,
                },
                on: {
                  "update:locked": function ($event) {
                    return _vm.$set(_vm.model, "locked", $event)
                  },
                  "update:enabled": function ($event) {
                    return _vm.$set(_vm.model, "enabled", $event)
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "v-card-text",
            { staticClass: "resizable-card__body" },
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  staticClass: "mr-2",
                  attrs: { small: "" },
                  on: {
                    click: function ($event) {
                      return _vm.showPreview()
                    },
                  },
                },
                [_vm._v("View JSON")]
              ),
              _c("v-spacer"),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6", sm: "6" } },
                    [
                      _c("v-text-field", {
                        directives: [
                          { name: "ascii-only", rawName: "v-ascii-only" },
                        ],
                        attrs: { label: "Key:" },
                        model: {
                          value: _vm.model.key,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.model,
                              "key",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "model.key",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6", sm: "6" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Code:" },
                        model: {
                          value: _vm.model.code,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "code", _vm._n($$v))
                          },
                          expression: "model.code",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6", md: "6" } },
                    [
                      _c("r-item-group-dropdown", {
                        attrs: { model: _vm.model.group },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "group", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6", sm: "6" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Priority:" },
                        model: {
                          value: _vm.model.priority,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "priority", _vm._n($$v))
                          },
                          expression: "model.priority",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                {
                  staticStyle: { "margin-top": "-12px" },
                  attrs: { dense: "" },
                },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("r-cell-kinds-select", {
                        model: {
                          value: _vm.model.cellKinds,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "cellKinds", $$v)
                          },
                          expression: "model.cellKinds",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "6" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Levels:" },
                        on: {
                          blur: function ($event) {
                            return _vm.parseLevels(_vm.levelsInput)
                          },
                        },
                        model: {
                          value: _vm.safeLevels,
                          callback: function ($$v) {
                            _vm.safeLevels = $$v
                          },
                          expression: "safeLevels",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "6" } },
                    [
                      _c("r-point", {
                        attrs: {
                          model: _vm.model.posHero,
                          label: "Position Hero",
                        },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "posHero", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                {
                  staticStyle: { "margin-top": "-12px" },
                  attrs: { dense: "" },
                },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "6" } },
                    [
                      _c("v-checkbox", {
                        attrs: { label: "Has Merge Prompt" },
                        model: {
                          value: _vm.safeHasMergePrompt,
                          callback: function ($$v) {
                            _vm.safeHasMergePrompt = $$v
                          },
                          expression: "safeHasMergePrompt",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "6" } },
                    [
                      _c("v-checkbox", {
                        attrs: { label: "Use Custom Icon" },
                        model: {
                          value: _vm.safeUseCustomIcon,
                          callback: function ($$v) {
                            _vm.safeUseCustomIcon = $$v
                          },
                          expression: "safeUseCustomIcon",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-expansion-panels",
                    { attrs: { focusable: "" } },
                    [
                      _c("r-owners-panel", { attrs: { model: _vm.model } }),
                      _c("r-maps-panel", { attrs: { model: _vm.model } }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            { staticClass: "resizable-card__actions" },
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.cancel },
                },
                [_vm._v(" Cancel ")]
              ),
              !_vm.lockedAssess || _vm.masterAccess
                ? _c(
                    "v-btn",
                    {
                      attrs: { color: "blue darken-1", text: "" },
                      on: { click: _vm.save },
                    },
                    [_vm._v(" Save ")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c("div", {
            staticClass: "resize-handle",
            on: { mousedown: _vm.startResize },
          }),
          _c("r-preview-dialog", { ref: "preview-dialog" }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }